<template>
     <b-row class="contenido">
        <b-col cols="12">
            <b-row v-for="(evento, index) in entradas" :key="index">
                <b-col cols="12" v-for="(item, subIndex) in evento.items" :key="subIndex">
                    <h3>
                        <strong>
                            <span class="text-primary">ENTRADA {{ ++subIndex }}: </span>
                            <span> 
                                <template v-if="item.asiento">
                                    <span> {{ item.asiento.zona_nombre }}</span>
                                    <span v-if="item.asiento.row"> | FILA: {{ item.asiento.row }}</span>
                                    <span v-if="item.asiento.asiento">| BUTACA: {{ item.asiento.asiento }}</span>
                                </template>
                                <template v-else-if="item.plaza">
                                    <span v-if="item.plaza.numero">{{ 'PLAZA: ' + item.plaza.numero }}</span>
                                    <span v-if="item.plaza.sector_name">SECTOR: {{ item.plaza.sector_name + ' | ' }}</span>
                                    <span>FILA: {{ item.plaza.fila }} </span>                                     
                                    <span>| BUTACA: {{ item.plaza.butaca }}</span>                              
                                </template>
                                <template v-else>
                                    <span>Sin numerar</span>
                                </template>
                                | PRECIO: 
                                <span id="precio_descuento" :style="item.descuento && item.descuento.slice(-3).trim() > 0 ? 'text-decoration:line-through' : ''">{{ (datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : item.entrada?.precio) | formatear_precio }}</span>
                                <span id="precio_descontado" v-if="item.descuento && item.descuento.slice(-3).trim() > 0" class="text-primary"> ({{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : calcularDescuento(item.entrada?.precio, item.descuento.slice(-2)) | formatear_precio }} / - {{ item.descuento.slice(-2) }}%)</span>
                            </span>
                        </strong>
                    </h3>
                    <b-col cols="12" class="pl-0">
                        <hr/>
                    </b-col>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12">
            <h2>
                <strong>
                    TOTAL: 
                    <span id="total_descuento" class="display-4" :style="total_descuento != total ? 'text-decoration:line-through' : ''">{{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : total | formatear_precio }}</span>
                    <span id="total_descontado" v-if="total_descuento != total" class="display-4 text-primary">({{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : total_descuento | formatear_precio }})</span>
                </strong>
            </h2>
        </b-col>
        <b-col cols="12">
            <h2><strong>FORMA DE PAGO: <span class="display-4">{{ datos_compra.metodo_pago.nombre }}</span></strong></h2>
            <PaymentCalculator class="mb-3" :amountDue="totalPaymentCalculator" v-if="totalPaymentCalculator > 0 && datos_compra.metodo_pago.id == 1" />
        </b-col>   
    </b-row>
</template>

<script>
import PaymentCalculator from '@/components/common/PaymentCalculator';

export default {
    props: {
        entradas: {
            type: Array,
            required: true
        },
        datos_compra: {
            type: Object,
            required: true
        }
    },
    methods: {
        calcularPrecio(item) {
            let importe = item.entrada?.precio ?? item.precio_unidad;

            if (item.entrada) {
                if (item.entrada.price_management_interno == 0) {
                    importe = parseFloat(importe) + item.entrada.price_management;
                }
            }

            return importe;
        },
        calcularDescuento(importe, descuento) {
            if (!descuento) {
                return importe;
            }

            const valorDescuento = (importe * descuento) / 100;
            return importe - valorDescuento;
        }
    },
    computed: {
        total() {
            if (this.entradas) {
                return this.entradas.reduce((total, item) => {
                    return total + item.items.reduce((subTotal, subItem) => {
                        let precioTotal = (subItem.entrada?.precio ?? subItem.precio_unidad) * subItem.units;

                        if (subItem.entrada && !subItem.entrada.price_management_interno) {
                            precioTotal += subItem.entrada.price_management * subItem.units;
                        }

                        return subTotal + precioTotal;
                    }, 0);
                }, 0);
            }
            return 0;
        },
        total_descuento() {
            if (this.entradas) {
                return this.entradas.reduce((total, item) => {
                    return total + item.items.reduce((subTotal, subItem) => {
                        const descuento = subItem.descuento ? (1 - (subItem.descuento.slice(-3).trim() / 100)) : 1;
                        let precioConDescuento = (subItem.entrada?.precio ?? subItem.precio_unidad) * descuento * subItem.units;

                        if (!subItem.entrada.price_management_interno) {
                            precioConDescuento += subItem.entrada.price_management * subItem.units;
                        }

                        return subTotal + precioConDescuento;
                    }, 0);
                }, 0);
            }
            return 0;
        },
        totalPaymentCalculator() {
            return this.total != this.total_descuento ? this.total_descuento : this.total;
        }
    },
    components: {
        PaymentCalculator
    }
}
</script>

<style scoped>
    .contenido {
        background-color: #EDEDED;
        padding: 20px 40px;
        margin-bottom: 50px;
    }
</style>